import { ModalDeleteUploadedFile } from './ModalDeleteUploadedFile';

export default ModalDeleteUploadedFile;
